import update from 'immutability-helper'
import Inflection from 'inflection'
import * as React from 'react'
import { FormFor } from 'react-rails-form-helpers'
import {
  AbstractMembershipCheckoutForm,
  buildBaseCheckoutState,
  IBaseCheckoutProps,
  IBaseCheckoutState,
} from './AbstractMembershipCheckoutForm'
import { Address } from './Address'
import { AddressForm } from './Address/AddressForm'
import { Cart } from './Cart'
import { CustomerForm } from './Customer/CustomerForm'
import * as API from './lib/api'
import { PurchaseOption } from './lib/purchase_option'
import { PaymentForm } from './PaymentForm'
import { PromoCodeForm } from './PromoCodeForm'
import { PurchaseOptionsSelect } from './PurchaseOptionsSelect'
import { TermsOfService } from './TermsOfService'
import { Testimonials } from './Testimonials'
import { TrialRedesignForm } from './TrialRedesign/TrialRedesignForm'

declare var Routes: any

export interface IProps extends IBaseCheckoutProps {}

export interface IState extends IBaseCheckoutState {}

export class ControlMembershipCheckoutForm extends AbstractMembershipCheckoutForm<IProps, IState> {
  constructor(props: IProps) {
    super(props)

    this.state = buildBaseCheckoutState(props)
  }

  public applyPromoCode = (e: React.SyntheticEvent) => {
    const button = $(e.target)
    const form = button.parents('form').first()
    const { checkout } = this.state
    const { cashier } = checkout

    const updatedCashier = update(cashier, {errors: {$unset: ['promo_code']}})

    this.updateCashier(updatedCashier)

    $.post({
      url: Routes.igniter_membership_checkout_apply_promo_code_path(),
      data: form.serialize(),
      dataType: 'json',
    }).done(this.handlePromoCodeResponse)
  }

  public toggleUseDefaultBillingAddress = () => {
    const { checkout: { cashier } } = this.state

    const updatedCashier = update(
      cashier,
      {
        $toggle: ['use_default_billing_address'],
      },
    )

    this.updateCashier(updatedCashier, () => this.updateTaxInformation())
  }

  public cashierErrors() {
    const { checkout, taxInformation, paymentTokenErrors } = this.state
    const { cashier: { errors: cashierErrors } } = checkout
    const errorFields = Object.keys(cashierErrors)
    let errors = errorFields.map((field) => (
      <li key={field}>{field == 'base' ? '' : Inflection.titleize(field)} {cashierErrors[field]}</li>
    ))

    if (paymentTokenErrors && paymentTokenErrors.length > 0) {
      errors = errors.concat(
        paymentTokenErrors.map(({ code, text }) => (
          <li key={code}>Credit/Debit Card: {text}</li>
        )),
      )
    }

    errors = errors.concat(taxInformation.errors.map((e) => <li key={e}>{e}</li>))

    if (errors.length) {
      return (
        <div className="cashier-errors">
          <h2>Please correct the errors below to continue:</h2>
          <ul>
            {errors}
          </ul>
        </div>
      )
    }
  }

  public ctaText() {
    const { checkout } = this.state
    const { trial, signedIn } = checkout

    if (trial) {
      return 'Start My Trial'
    } else if (signedIn) {
      return 'Process My Order'
    }

    return  'Create My Account'
  }

  public render() {
    const {
      checkout,
      taxInformation,
    } = this.state
    const {
      trial,
      trialLength,
    } = checkout
    const selectedPurchaseOption = this.selectedPurchaseOption()
    const monthly: boolean = selectedPurchaseOption.name === 'monthly'
    const {
      membershipPlan,
      trialActivationPrice,
    } = selectedPurchaseOption
    const { code: planCode } = membershipPlan


    return (
      <div className="checkout membership-checkout">
        <div className="grid-x">
          <header className="cell">
            <h1>
              One More Step to {trial ? 'Start Your Free Trial' : 'Complete Your Purchase'}
            </h1>
          </header>
        </div>

        <div className="grid-container wide">
          <div className="grid-x">
            <div className="cell small-full mlarge-30 small-order-2 mlarge-order-1 checkout-form">
              <FormFor url={Routes.igniter_membership_checkout_path()} method="post" name="cashier">
                {this.cashierErrors()}

                {this.renderSections()}

                {planCode ? <input type="hidden" name="plan_code" value={planCode} /> : null}
                <input type="hidden" name="monthly" value={monthly ? 1 : 0} />
                {trial ? <input type="hidden" name="trial" value={trial ? 1 : 0} /> : null}

              </FormFor>

              {this.renderTestimonials()}
            </div>

            <div className="cell small-full mlarge-30 small-order-1 mlarge-order-2 order-preview">
              <Cart
                purchaseOption={selectedPurchaseOption}
                trialActivationPrice={trialActivationPrice}
                trial={trial}
                trialLength={trialLength}
                taxInformation={taxInformation}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  protected renderSections() {
    return this.checkoutSections().map((s) => (
      <React.Fragment key={s.id}>{s.render()}</React.Fragment>
    ))
  }

  protected renderTestimonials() {
    const { checkout: { testimonials } } = this.state
    return <Testimonials testimonials={testimonials} />
  }

  protected checkoutSections(): Array<{ id: string; render: () => React.ReactNode }> {
    const { checkout, taxInformation, paymentToken } = this.state
    const {
      cashier,
      signedIn,
      trial,
      trialLength,
      purchaseOptions,
    } = checkout
    const selectedPurchaseOption = this.selectedPurchaseOption()
    const {
      customer,
      payment_type: paymentType,
      payment_profiles: paymentProfiles,
      payment_profile_id: selectedPaymentProfileId,
      credit_card: creditCard,
      terms_of_service: termsOfService,
    } = cashier
    const { current_membership_is_trial: currentMembershipIsTrial } = customer
    const { paymentDetails, membershipPlan } = selectedPurchaseOption
    const { code: planCode, totalIncludedItemsInTrial } = membershipPlan
    const promoCodeSuppressed = (currentMembershipIsTrial && planCode == membershipPlan.slug) || trial

    return [
      {
        id: 'customer',
        render: () => (signedIn ? null : <CustomerForm customer={customer} />),
      },
      {
        id: 'address',
        render: () => this.renderAddress(),
      },
      {
        id: 'payment',
        render: () => (
          <PaymentForm
            paymentProfiles={paymentProfiles}
            selectedPaymentProfileId={selectedPaymentProfileId}
            creditCard={creditCard}
            paymentType={paymentType}
            paymentToken={paymentToken}
          >
            <label htmlFor="purchase_option_select">
              Choose the billing option that best fits your needs
            </label>
            <PurchaseOptionsSelect
              purchaseOptions={purchaseOptions}
              selectedPurchaseOptionName={selectedPurchaseOption.name}
              onPurchaseOptionChange={this.onPurchaseOptionChange}
            />
          </PaymentForm>
        ),
      },
      {
        id: 'promoCode',
        render: () => (promoCodeSuppressed ? null : this.renderPromoCodeForm()),
      },
      {
        id: 'termsOfService',
        render: () => (
          <TermsOfService
            termsOfService={termsOfService}
            totalIncludedItemsInTrial={totalIncludedItemsInTrial}
            paymentDetails={paymentDetails}
            taxInformation={taxInformation}
            trial={trial}
            trialLength={trialLength}
            ctaText={this.ctaText()}
            onCashierSubmit={this.onCheckoutFormSubmit}
          />
        ),
      },
    ]
  }

  protected renderAddress() {
    const { checkout } = this.state
    const {
      cashier,
      stateSelectOptions,
      countrySelectOptions,
      signedIn,
    } = checkout
    const {
      billing_address: billingAddress,
      default_billing_address: defaultBillingAddress,
      use_default_billing_address: useDefaultBillingAddress,
      customer,
    } = cashier
    const title = signedIn ? 'Account Information' : 'Billing Address'

    if (useDefaultBillingAddress) {
      return (
        <Address
          address={defaultBillingAddress}
          signedIn={signedIn}
          customer={customer}
          addressType="billing"
          toggleUseDefaultBillingAddress={this.toggleUseDefaultBillingAddress}
        />
        )
    } else {
      return (
        <AddressForm
          address={billingAddress}
          addressType="billing"
          stateSelectOptions={stateSelectOptions}
          countrySelectOptions={countrySelectOptions}
          toggleUseDefaultBillingAddress={this.toggleUseDefaultBillingAddress}
          allowUsingDefault={!!defaultBillingAddress}
          onAddressChanged={this.billingAddressChanged}
          title={title}
        />
        ) }
  }

  protected renderPromoCodeForm() {
    const { checkout: { cashier } } = this.state
    const {
      allow_promo_code: allowPromoCode,
      promo_code: promoCode,
      errors,
    } = cashier

    if (!allowPromoCode) { return }

    return (
      <PromoCodeForm
        promoCode={promoCode}
        applyPromoCode={this.applyPromoCode}
        errors={errors.promo_code}
      />
      )
  }

  protected onPurchaseOptionChange = (purchaseOptionName: API.PurchaseOptionNameType) => {
    this.setState(
      {
        selectedPurchaseOptionName: purchaseOptionName,
      },
      () => this.updateTaxInformation(),
    )
  }

  protected handlePromoCodeResponse = (response: API.IPromoCodeResponse) => {
    const { checkout } = this.state
    const { cashier } = checkout
    const { checkout: checkoutResponse } = response
    const { purchase_options: purchaseOptions } = checkoutResponse
    const { promo_code, errors } = checkoutResponse.cashier

    let setErrors = {}
    if (errors.promo_code) {
      setErrors = { promo_code: { $set: errors.promo_code } }
    } else {
      setErrors = { $unset: ['promo_code'] }
    }

    const newPurchaseOptions = purchaseOptions.map((o) => new PurchaseOption(o))

    const updatedCashier = update(
      cashier,
      {
        promo_code: {$set: promo_code},
        errors: setErrors,
      },
    )

    this.setState({
      checkout: {
        ...checkout,
        cashier: updatedCashier,
        purchaseOptions: newPurchaseOptions,
      },
    })
  }
}

// trial_redesign_v1 (CD-146/CD-147): the structural variant seam. This wrapper
// keeps the `MembershipCheckoutForm` export name that the pack and the ERB
// `react_component` mount depend on, while routing the experiment branch to a
// single place above the control component. When the visitor is assigned the
// `redesign` variant, render the redesigned shell — which owns its own state,
// Accept.js load, and tax recalculation. Any other assignment (including no
// assignment) renders the unchanged control form. Because the control
// component never mounts in the redesign arm, none of its side effects (a
// duplicate Accept.js <script>, a never-displayed sales-tax request) fire —
// no in-component guard required. `TwoYearCheckout`/`ThreeYearCheckout` extend
// `ControlMembershipCheckoutForm` directly and bypass this seam entirely.
export function MembershipCheckoutForm(props: IProps) {
  if (props.checkout.experiment_variants?.trial_redesign_v1 === 'redesign') {
    return <TrialRedesignForm {...props} />
  }
  return <ControlMembershipCheckoutForm {...props} />
}
